export default __webpack_public_path__ + "static/media/sunglasses.be384348.svg";